import type { SxProps, Theme } from '@mui/material';
import { Box, Paper, Skeleton, Typography } from '@mui/material';
import { isNotNullOrUndefined } from '@weft/utils';
import React from 'react';

const outlinedPaperStyle: SxProps<Theme> = {
  padding: 2,
  borderRadius: '8px',
  position: 'relative',
  overflow: 'hidden',
  fontFamily: 'Inter',
  width: '100%',
};

const titleStyle: SxProps<Theme> = {
  fontWeight: '500',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  wordWrap: 'break-word',
  color: 'rgba(27, 61, 85, 0.60)',
};

export const PlansSumCard: React.FC<any> = ({ title, value }) => {
  return (
    <>
      <Paper sx={outlinedPaperStyle}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Typography
            sx={titleStyle}
          >
            {title}
          </Typography>

          <Typography
            variant='h6'
            letterSpacing={0.15}
            marginLeft='auto'
          >
            {isNotNullOrUndefined(value) ? 
              value 
              : <Skeleton
                  variant="text"
                  animation="wave"
                  sx={{
                    '&::after': {
                      animationDuration: '1s',
                      backgroundColor: 'rgba(0, 0, 0, 0.02)',
                    },
                  }}
                />}
          </Typography>

        </Box>
      </Paper> 
    </>

  );
};